import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTwitter20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTwitter20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M16.362 7.738c.01.12.01.24.01.36 0 3.67-3.302 7.902-9.34 7.902v-.002C5.248 16 3.502 15.568 2 14.753q.39.04.781.04c1.478 0 2.914-.419 4.077-1.191-1.404-.023-2.636-.798-3.067-1.93.492.081 1 .065 1.482-.047-1.531-.262-2.633-1.4-2.633-2.722v-.036c.457.216.967.335 1.49.348C2.688 8.4 2.243 6.776 3.114 5.507 4.781 7.242 7.24 8.297 9.88 8.408c-.264-.964.097-1.975.95-2.653 1.322-1.052 3.402-.998 4.644.12a7.4 7.4 0 0 0 2.085-.674c-.245.643-.758 1.189-1.443 1.536A7.5 7.5 0 0 0 18 6.3a6.2 6.2 0 0 1-1.638 1.438"
            />
        </svg>
    );
}
export default memo(IconTwitter20);
